import React from 'react';

import { Check, Delete, Edit } from '@mui/icons-material';
import { Box, IconButton, TableCell, TableRow } from '@mui/material';

import { SchemaPropertyModel } from '../../../api/api';
import CopyToClipboardButton from '../../../components/Clipboard/CopyToClipboardButton';
import PropertyTypeIcon from './PropertyTypeIcon';

interface Props {
	prop: SchemaPropertyModel;
	onDelete: (propertyName: string) => void;
	onEditProperty: (property: SchemaPropertyModel) => Promise<void> | void;
	enumTypeName?: string;
}

const PropertyRow: React.FC<Props> = ({ prop, onDelete, onEditProperty, enumTypeName }) => {
	const onEdit = () => {
		onEditProperty(prop);
	};

	const typeLabel = prop.isEnum && enumTypeName ? `Enum: ${enumTypeName}` : prop.type;

	return (
		<TableRow>
			<TableCell>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
					<PropertyTypeIcon prop={prop} />
					<Box component="span" sx={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
						{prop.name}
					</Box>
					<CopyToClipboardButton value={prop.name} title="Copy property name to clipboard" edge={false} iconSize={14} sx={{ p: 0.25, flexShrink: 0 }} />
				</Box>
			</TableCell>
			<TableCell>{typeLabel}</TableCell>
			<TableCell sx={{ px: 0.5, textAlign: 'center' }}>{prop.isRequired && <Check fontSize="small" />}</TableCell>
			<TableCell sx={{ px: 0.5, textAlign: 'center' }}>{prop.isMultiple && <Check fontSize="small" />}</TableCell>
			<TableCell>{prop.defaultValue ?? '-'}</TableCell>
			<TableCell align="right">
				<IconButton
					size="small"
					onClick={() => {
						if (prop.name) {
							onEdit();
						}
					}}
				>
					<Edit fontSize="small" />
				</IconButton>
				<IconButton
					size="small"
					onClick={() => {
						if (prop.name) {
							onDelete(prop.name);
						}
					}}
				>
					<Delete fontSize="small" />
				</IconButton>
			</TableCell>
		</TableRow>
	);
};

export default PropertyRow;
